export { default } from './SearchResults';



// WEBPACK FOOTER //
// ./app/components/search/SearchResults/index.js